export default "__VITE_ASSET__UeVfTH2k__"